// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 768px)";
var _3 = "controls-AVEVA";
var _4 = "button-12hTh";
var _5 = "back-3W_jy";
export { _1 as "__esModule", _2 as "tabletMiddle", _3 as "controls", _4 as "button", _5 as "back" }
export default { "__esModule": _1, "tabletMiddle": _2, "controls": _3, "button": _4, "back": _5 }
